import { Home, ShoppingBag, Sparkles, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const USE_CASES = [
  {
    icon: Home,
    name: "Real Estate",
    headline: "Every comment is a potential viewing.",
    body: "Realtors and letting agents post a property Reel and instantly drown in 'is this still available?' comments. Set a keyword flow on \"available\" → DM the full listing PDF, the asking price, and a Calendly link for a viewing. The qualified buyer is on your calendar before a competitor even sees the comment.",
    keyword: "available",
    reply: "Hi! Yes, it's still available. Here's the full listing pack and a link to book a 15-min viewing →",
    testid: "use-case-real-estate",
  },
  {
    icon: ShoppingBag,
    name: "E-commerce",
    headline: "Turn product Reels into Stripe checkouts.",
    body: "DTC brands lose 60% of comment-driven demand because by the time they reply, the dopamine is gone. Auto-reply with the product link, the current discount code, and the shipping cut-off — within seconds. One creator who switched to InstaVibe added £4,200/mo of attributable Instagram revenue in the first 30 days.",
    keyword: "price",
    reply: "Thanks for the love! Here's the product page + code SAVE10 for 10% off. Free shipping over £40 →",
    testid: "use-case-ecommerce",
  },
  {
    icon: Sparkles,
    name: "Influencers & Creators",
    headline: "Sell your ebook from a single Reel.",
    body: "Creators with lead-magnet funnels live or die by DM speed. Drop a Reel teasing your guide, ask people to comment \"GUIDE\" — InstaVibe replies publicly thanking them, then privately DMs the Gumroad link with a one-line personalised note. Your funnel runs itself while you film the next video.",
    keyword: "guide",
    reply: "Just sent it to your DMs — enjoy! 💜 If you grab the paid bundle this week, use INSTAVIBE for 20% off.",
    testid: "use-case-creators",
  },
];

export default function UseCases() {
  return (
    <section
      id="use-cases"
      className="py-20 sm:py-24 md:py-32 px-4 sm:px-6 md:px-12 max-w-[1400px] mx-auto"
      data-testid="landing-use-cases-section"
    >
      <div className="mb-10 sm:mb-14 max-w-3xl">
        <div className="overline mb-3">— Use cases</div>
        <h2 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl tracking-tighter leading-tight" data-testid="landing-use-cases-heading">
          Built for the people<br className="hidden sm:block" /> who live in their DMs.
        </h2>
        <p className="mt-5 text-base sm:text-lg text-white/70 leading-relaxed">
          Three of our most active customer segments. If you sell, schedule, or share through Instagram — there is a flow waiting for you.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-4 sm:gap-6">
        {USE_CASES.map((uc) => {
          const Icon = uc.icon;
          return (
            <div
              key={uc.name}
              className="surface-card p-6 sm:p-7 flex flex-col"
              data-testid={uc.testid}
            >
              <Icon className="w-6 h-6 text-klein mb-4" strokeWidth={1.5} />
              <div className="overline mb-2 text-cyan">{uc.name}</div>
              <div className="font-heading font-bold text-lg sm:text-xl tracking-tight leading-snug mb-3">
                {uc.headline}
              </div>
              <p className="text-sm text-white/70 leading-relaxed mb-5 flex-1">{uc.body}</p>
              <div className="border-t border-white/5 pt-4 mt-auto space-y-2">
                <div className="text-[11px] uppercase tracking-wider text-white/40">Example flow</div>
                <div className="text-xs">
                  <span className="text-white/50">Trigger:</span> <span className="font-mono font-bold text-klein">{uc.keyword}</span>
                </div>
                <div className="text-xs text-white/70 leading-relaxed">
                  <span className="text-white/50">Reply:</span> "{uc.reply}"
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-10 sm:mt-12 text-center">
        <Link to="/signup" className="btn-primary w-full sm:w-auto inline-flex justify-center" data-testid="use-cases-cta">
          Build your flow free for 14 days <ArrowUpRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
